// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Thorchain Unchained API
 * Provides access to thorchain chain data.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Value } from './Value';
import {
    ValueFromJSON,
    ValueFromJSONTyped,
    ValueToJSON,
} from './Value';

/**
 * Contains info about account details for an address or xpub
 * @export
 * @interface Account
 */
export interface Account {
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    balance: string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    pubkey: string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    unconfirmedBalance: string;
    /**
     * 
     * @type {number}
     * @memberof Account
     */
    accountNumber: number;
    /**
     * 
     * @type {Array<Value>}
     * @memberof Account
     */
    assets: Array<Value>;
    /**
     * 
     * @type {number}
     * @memberof Account
     */
    sequence: number;
}

/**
 * Check if a given object implements the Account interface.
 */
export function instanceOfAccount(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "balance" in value;
    isInstance = isInstance && "pubkey" in value;
    isInstance = isInstance && "unconfirmedBalance" in value;
    isInstance = isInstance && "accountNumber" in value;
    isInstance = isInstance && "assets" in value;
    isInstance = isInstance && "sequence" in value;

    return isInstance;
}

export function AccountFromJSON(json: any): Account {
    return AccountFromJSONTyped(json, false);
}

export function AccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): Account {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'balance': json['balance'],
        'pubkey': json['pubkey'],
        'unconfirmedBalance': json['unconfirmedBalance'],
        'accountNumber': json['accountNumber'],
        'assets': ((json['assets'] as Array<any>).map(ValueFromJSON)),
        'sequence': json['sequence'],
    };
}

export function AccountToJSON(value?: Account | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'balance': value.balance,
        'pubkey': value.pubkey,
        'unconfirmedBalance': value.unconfirmedBalance,
        'accountNumber': value.accountNumber,
        'assets': ((value.assets as Array<any>).map(ValueToJSON)),
        'sequence': value.sequence,
    };
}

